import createAdminResource from 'lib/admin-kit/createAdminResource';
import config from './config';

export default createAdminResource(config).Edit;
